/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Select_PlaceholderInputs */

const en_clients_select_placeholder = /** @type {(inputs: Clients_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select…`)
};

const pt_br2_clients_select_placeholder = /** @type {(inputs: Clients_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar…`)
};

/**
* | output |
* | --- |
* | "Select…" |
*
* @param {Clients_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_select_placeholder = /** @type {((inputs?: Clients_Select_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Select_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_select_placeholder(inputs)
	return pt_br2_clients_select_placeholder(inputs)
});